import React, { useEffect, useState } from "react";
import { CgAdd, CgChevronDown, CgChevronUp } from "react-icons/cg";
import { useAuth } from "../../../../Contexts/AuthContext/AuthContext";
import { useProperty } from "../../../../Contexts/PropertyContext/PropertyContext";
import { toast } from "react-toastify";
import { baseUrl } from "../../../../Environments/environment";
import LoadingSpinner from "../../../LoadingSpinner/LoadingSpinner";
import { Switch } from "@headlessui/react";
import { FaEye, FaTrash } from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";
import NewFlowModal from "./NewFlowModal";
import RoomType from "../../../RoomTypeModal/RoomType.jsx";
import TierType from "../../../TierTypeModal/TierType.jsx";
import Ac from "../../../SvgComponents/AC.jsx";
import Breakfast from "../../../SvgComponents/Breakfast.jsx";
import Breakfast2 from "../../../SvgComponents/Breakfast2.jsx";
import Commute from "../../../SvgComponents/Commute.jsx";
import Frontdesk from "../../../SvgComponents/Frontdesk.jsx";
import Gym from "../../../SvgComponents/Gym.jsx";
import HomeService from "../../../SvgComponents/HomeService.jsx";
import Laundry from "../../../SvgComponents/Laundry.jsx";
import Luggae2 from "../../../SvgComponents/Luggae2.jsx";
import Luggage from "../../../SvgComponents/Luggage.jsx";
import Minibar from "../../../SvgComponents/Minibar.jsx";
import Parking from "../../../SvgComponents/Parking.jsx";
import Pet from "../../../SvgComponents/Pet.jsx";
import Spa from "../../../SvgComponents/Spa.jsx";
import Swimming from "../../../SvgComponents/Swimming.jsx";
import Wheelchair from "../../../SvgComponents/Wheelchair.jsx";
import Wifi from "../../../SvgComponents/Wifi.jsx";
import Wine from "../../../SvgComponents/Wine.jsx";
import Tv from "../../../SvgComponents/TV.jsx";
import { apiClient } from "../../../../api/index.js";
import { Info } from "lucide-react";
const arr = [
	<Wifi />,
	<Breakfast />,
	<HomeService />,
	<Gym />,
	<Swimming />,
	<Luggae2 />,
	<Breakfast2 />,
	<Frontdesk />,
	<Parking />,
	<Ac />,
	<Minibar />,
	<Laundry />,
	<Commute />,
	<Pet />,
	<Wine />,
	<Spa />,
	<Tv />,
	<Luggage />,
	<Wheelchair />,
];
const obj = {
	freeWiFi: Wifi,
	complimentaryBreakfast: Breakfast2,
	roomService: HomeService,
	fitnessCenterGym: Gym,
	swimmingPool: Swimming,
	businessCenter: Luggae2,
	onSiteRestaurantBar: Wine,
	conciergeService: Breakfast,
	parking: Parking,
	airConditioningHeating: Ac,
	frontDesk: Frontdesk,
	laundryServices: Laundry,
	airportShuttleService: Commute,
	petFriendlyAccommodations: Pet,
	miniBar: Minibar,
	spaWellnessCenter: Spa,
	cableSatelliteTV: Tv,
	luggageStorage: Luggage,
	wheelchairAccessibility: Wheelchair,
};

const ConfirmModal = ({ open, review, onConfirm, onCancel }) => {
	if (!open || !review) return null;
	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
			<div className="bg-white w-full max-w-md rounded-lg shadow-xl p-6">
				<h3 className="text-lg font-semibold mb-2">
					Are you sure want to delete this review job?
				</h3>
				<div className="mb-4 text-gray-700 text-sm">
					<span className="font-semibold ">Network:</span> {review?.network}
					<br />
					<span className="font-semibold ">Review Job ID:</span>{" "}
					{review?.reviewJobId}
				</div>
				<div className="flex justify-end gap-3">
					<button
						onClick={onCancel}
						className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300"
					>
						No
					</button>
					<button
						onClick={onConfirm}
						className="px-4 py-2 rounded bg-indigo-600 text-white hover:bg-indigo-700"
					>
						Yes
					</button>
				</div>
			</div>
		</div>
	);
};

export const Workflow = () => {
	const { accessToken } = useAuth();
	const { selectedPropertyId } = useProperty();
	const [loading, setLoading] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [activate, setActivate] = useState(true);
	const [workflowData, setWorkflowData] = useState();
	const [selectedAmenities, setSelectedAmenities] = useState([]);
	const [isNewFlowModalOpen, setIsNewFlowModalOpen] = useState(false);
	const [isRoomTypeModalOpen, setIsRoomTypeModalOpen] = useState(false);
	const [selectedRoomData, setSelectedRoomData] = useState(null);
	const [roomTypeAction, setRoomTypeAction] = useState(null);
	const [tierTypeAction, setTierTypeAction] = useState(null);
	const [selectedTierData, setSelectedTierData] = useState(null);
	const [isTierTypeModalOpen, setIsTierTypeModalOpen] = useState(false);
	const [tierType, setTierType] = useState([]);
	const [roomType, setRoomType] = useState([]);

	// RoomType Modal handlers
	const openRoomTypeModal = (roomData, action) => {
		// If roomData exists, add tierType name using getTierNameById
		if (roomData) {
			const tierName = getTierNameById(
				roomData.tierTypeId,
				addOnsFlow.upgradeRoom.tiers,
			);
			const enhancedRoomData = {
				...roomData,
				tierType: tierName,
			};
			setSelectedRoomData(enhancedRoomData);
		} else {
			setSelectedRoomData(roomData);
		}
		setRoomTypeAction(action);
		setIsRoomTypeModalOpen(true);
	};

	const refreshUpgradeRoomData = async () => {
		try {
			const propertyId = localStorage.getItem("selectedPropertyId");
			const token = localStorage.getItem("accessToken");

			const response = await apiClient.get(
				`${baseUrl}/upgradeRoomWorkflow/roomType/${propertyId}`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				},
			);

			if (response.status === 200) {
				console.log("Upgrade room data refreshed:", response.data);
				console.log("Response structure:", {
					result: response.data.result,
					roomType: response.data.result?.roomType,
					isArray: Array.isArray(response.data.result?.roomType),
				});
				// Update the addOnsFlow state with fresh data
				const optionsData =
					response.data.result?.roomType || response.data.result || [];
				setRoomType(optionsData);
				setAddOnsFlow((prev) => ({
					...prev,
					upgradeRoom: {
						...prev.upgradeRoom,
						options: response.data.result.roomType || [],
					},
				}));
			}
		} catch (error) {
			console.error("Error refreshing upgrade room data:", error);
		}
	};

	const refreshTierData = async () => {
		try {
			const propertyId = localStorage.getItem("selectedPropertyId");
			const token = localStorage.getItem("accessToken");

			const response = await apiClient.get(
				`${baseUrl}/upgradeRoomWorkflow/tierData/${propertyId}`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				},
			);

			if (response.status === 200) {
				console.log("Tier data refreshed:", response.data);
				setTierType(response.data.result?.tierData || []);
				// Update the addOnsFlow state with fresh tier data
				setAddOnsFlow((prev) => ({
					...prev,
					upgradeRoom: {
						...prev.upgradeRoom,
						tiers: response.data.result?.tierData || [],
					},
				}));
				await refreshUpgradeRoomData();
			}
		} catch (error) {
			console.error("Error refreshing tier data:", error);
		}
	};

	const closeRoomTypeModal = () => {
		setIsRoomTypeModalOpen(false);
		setSelectedRoomData(null);
	};

	const openTierTypeModal = (tierData, action) => {
		setSelectedTierData(tierData);
		setTierTypeAction(action);
		setIsTierTypeModalOpen(true);
	};

	const closeTierTypeModal = () => {
		setIsTierTypeModalOpen(false);
		setSelectedTierData(null);
	};

	const [isExpandedHome, setIsExpandedHome] = useState(false);
	const [isExpandedAmenities, setIsExpandedAmenities] = useState(false);
	const [isExpandedArrival, setIsExpandedArrival] = useState(false);
	const [isFaqEnabled, setIsFaqEnabled] = useState(false);
	const [isExpandedInHouse, setIsExpandedInHouse] = useState(false);
	const [isExpandedReviews, setIsExpandedReviews] = useState(false);
	const [isExpandedCheckedOut, setIsExpandedCheckedOut] = useState(false);
	const [isExpandedAddOns, setIsExpandedAddOns] = useState(false);
	const [faqList, setFaqList] = useState([]);
	const [flowUpdateLoader, setFlowUpdateLoader] = useState(false);
	const [hoveredIndex, setHoveredIndex] = useState(null);
	const [preArrivalData, setPreArrivalData] = useState({
		phoneNumber: true,
		emailAddress: true,
		arrivalTime: true,
		vehicleMakeModelColor: true,
		licensePlateNo: true,
		specialRequests: true,
		guestSignature: true,
		guestIdProof: true,
		policies: true,
		primaryPolicy: "",
		policyLink: "",
		extraPolicies: [],
	});
	const [inHouseFlow, setInHouseFlow] = useState({
		wifiDetailsEnabled: false,
		wifiDetails: { wifiName: "", wifiInstructions: "" },
		clickableLinksOrButtonsEnabled: false,
		clickableLinksOrButtons: [],
		frequentlyAskedQuestionsEnabled: false,
		frequentlyAskedQuestions: [],
	});

	const [checkedOutFlow, setCheckedOutFlow] = useState({
		frequentlyAskedQuestionsEnabled: false,
		frequentlyAskedQuestions: [{ question: "", answer: "" }],
	});

	const [addOnsFlow, setAddOnsFlow] = useState({
		customAddOns: [
			{
				name: "",
				description: "",
				addonNote: "",
				paid: false,
				price: 0,
				enabled: false,
				default: false,
			},
		],
		checkInOutAddOns: [
			{
				name: "",
				description: "",
				addonNote: "",
				defaultTimeEnabled: false,
				defaultTiming: "",
				customTiming: "",
				paid: false,
				price: 0,
				enabled: false,
				default: false,
			},
		],
		houseKeepingAddOns: {
			name: "House Keeping",
			description: "",
			enabled: false,
			default: true,
			options: [],
			serviceTiming: { from: "", to: "" },
			serviceTimingEnabled: false,
		},
		upgradeRoom: {
			name: "Upgrade Room",
			default: true,
			image: [],
			options: [],
			tiers: [],
		},
	});

	const [reviewsFlow, setReviewsFlow] = useState({
		reviewsLink: "",
		startLimitForReviewLink: 1,
	});
	console.log("setReviewsFlow", reviewsFlow);

	// Reviews Job Flow state
	const [reviewsJobFlow, setReviewsJobFlow] = useState({
		reviewJobs: [],
	});
	const [isAddingReviewJob, setIsAddingReviewJob] = useState(false);
	const [isUpdatingReviewJob, setIsUpdatingReviewJob] = useState(false);
	const [editingJobId, setEditingJobId] = useState(null);
	const [newReviewJob, setNewReviewJob] = useState({
		network: "",
		networkUrl: "",
	});
	const [editingReviewJob, setEditingReviewJob] = useState({
		network: "",
		networkUrl: "",
	});

	// Available networks for review jobs
	const availableNetworks = [
		{ value: "google", label: "Google" },
		{ value: "tripadvisor", label: "TripAdvisor" },
		{ value: "yelp", label: "Yelp" },
		{ value: "booking", label: "Booking.com" },
		{ value: "expedia", label: "Expedia" },
		{ value: "agoda", label: "Agoda" },
	];
	const [confirmModal, setConfirmModal] = useState({
		open: false,
		review: null,
	});

	// Get available networks excluding already used ones (for add mode)
	const getAvailableNetworks = () => {
		const usedNetworks = reviewsJobFlow.reviewJobs.map((job) => job.network);
		return availableNetworks.filter(
			(network) => !usedNetworks.includes(network.value),
		);
	};

	// Get available networks for editing (include current network)
	const getAvailableNetworksForEdit = (currentNetwork) => {
		const usedNetworks = reviewsJobFlow.reviewJobs
			.filter((job) => job._id !== editingJobId)
			.map((job) => job.network);
		return availableNetworks.filter(
			(network) =>
				!usedNetworks.includes(network.value) ||
				network.value === currentNetwork,
		);
	};

	const handleAddReviewJob = async () => {
		if (
			!newReviewJob.network ||
			!newReviewJob.networkUrl ||
			!newReviewJob.redirectUrl
		) {
			toast.error("Please fill in all fields");
			return;
		}

		try {
			setIsAddingReviewJob(true);
			const token = localStorage.getItem("accessToken");

			const response = await apiClient.post(
				`${baseUrl}/reviews/jobs/${selectedPropertyId}`,
				{
					network: newReviewJob.network,
					networkUrl: newReviewJob.networkUrl,
					redirectUrl: newReviewJob.redirectUrl,
				},
				{
					headers: { Authorization: `Bearer ${token}` },
				},
			);

			if (response.data.statusCode === 201) {
				toast.success("Review job added successfully!");
				// Reset form
				setNewReviewJob({
					network: "",
					networkUrl: "",
					redirectUrl: "",
				});
				// Refresh review jobs
				fetchReviewJobs();
			}
		} catch (error) {
			console.error("Error adding review job:", error);
			const errorMessage =
				error.response?.data?.message || "Failed to add review job";
			toast.error(errorMessage);
		} finally {
			setIsAddingReviewJob(false);
		}
	};

	const handleUpdateReviewJob = async () => {
		// if (!editingReviewJob.network || !editingReviewJob.networkUrl) {
		//   toast.error("Please fill in all fields");
		//   return;
		// }
		if (!editingReviewJob.redirectUrl) {
			toast.error("Please fill in all fields");
			return;
		}

		try {
			setIsUpdatingReviewJob(true);
			const token = localStorage.getItem("accessToken");

			const response = await apiClient.put(
				`${baseUrl}/reviews/jobs/${selectedPropertyId}/${editingJobId}`,
				{
					// network: editingReviewJob.network,
					// networkUrl: editingReviewJob.networkUrl,
					redirectUrl: editingReviewJob.redirectUrl,
				},
				{
					headers: { Authorization: `Bearer ${token}` },
				},
			);

			if (response.data.statusCode === 200) {
				toast.success("Review job updated successfully!");
				// Exit edit mode
				setEditingJobId(null);
				setEditingReviewJob({
					network: "",
					networkUrl: "",
					redirectUrl: "",
				});
				// Refresh review jobs
				fetchReviewJobs();
			}
		} catch (error) {
			console.error("Error updating review job:", error);
			const errorMessage =
				error.response?.data?.message || "Failed to update review job";
			toast.error(errorMessage);
		} finally {
			setIsUpdatingReviewJob(false);
		}
	};

	const handleEditReviewJob = (job) => {
		setEditingJobId(job._id);
		setEditingReviewJob({
			network: job.network,
			networkUrl: job.networkUrl || job.networkUrl,
			redirectUrl: job.redirectUrl,
		});
	};
	const handleIsDefault = async (jobId, isDefault) => {
		// Update local state immutably
		const updatedJobs = reviewsJobFlow.reviewJobs.map((r) =>
			r._id === jobId ? { ...r, isDefault } : { ...r, isDefault: false },
		);
		setReviewsJobFlow({ reviewJobs: updatedJobs });

		// Find the updated job for API payload
		const updatedJob = updatedJobs.find((r) => r._id === jobId);

		try {
			const token = localStorage.getItem("accessToken");
			const response = await apiClient.put(
				`${baseUrl}/reviews/jobs/${selectedPropertyId}/${jobId}`,
				updatedJob,
				{ headers: { Authorization: `Bearer ${token}` } },
			);

			if (response.data.statusCode === 200) {
				toast.success("Review job updated successfully!");
				setNewReviewJob({ network: "", networkUrl: "", redirectUrl: "" });
				fetchReviewJobs();
			}
		} catch (error) {
			console.error("Error updating review job:", error);
			toast.error(
				error.response?.data?.message || "Failed to update review job",
			);
			fetchReviewJobs(); // Sync back to server state on error
		} finally {
			setIsAddingReviewJob(false);
		}
	};

	const handleCancelEdit = () => {
		setEditingJobId(null);
		setEditingReviewJob({
			network: "",
			networkUrl: "",
			redirectUrl: "",
		});
	};

	const handleDeleteReviewJob = async () => {
		try {
			const review = confirmModal.review;
			setConfirmModal({ open: false, review: null });
			const jobId = review._id;
			if (jobId) {
				const token = localStorage.getItem("accessToken");

				const response = await apiClient.delete(
					`${baseUrl}/reviews/jobs/${selectedPropertyId}/${jobId}`,
					{
						headers: { Authorization: `Bearer ${token}` },
					},
				);

				if (response.data.statusCode === 200) {
					toast.success("Review job deleted successfully!");
					fetchReviewJobs();
				}
			}
		} catch (error) {
			console.error("Error deleting review job:", error);
			const errorMessage =
				error.response?.data?.message || "Failed to delete review job";
			toast.error(errorMessage);
		}
	};

	const fetchReviewJobs = async () => {
		try {
			const token = localStorage.getItem("accessToken");

			const response = await apiClient.get(
				`${baseUrl}/reviews/jobs/${selectedPropertyId}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				},
			);

			if (response.data.statusCode === 200) {
				setReviewsJobFlow({
					reviewJobs: response.data.result.reviewJobs || [],
				});
			}
		} catch (error) {
			console.error("Error fetching review jobs:", error);
		}
	};

	const preArrivalFlowInputChange = (e) => {
		setPreArrivalData((prev) => ({
			...prev,
			[e.target.name]: e.target.value,
		}));
	};
	const toggleExpandHome = () => {
		setIsExpandedHome(!isExpandedHome);
	};
	const toggleExpandAmenities = () => {
		setIsExpandedAmenities(!isExpandedAmenities);
	};

	const toggleExpandArrival = () => {
		setIsExpandedArrival(!isExpandedArrival);
	};
	const toggleExpandInHouse = () => setIsExpandedInHouse(!isExpandedInHouse);
	const toggleExpandReviews = () => setIsExpandedReviews(!isExpandedReviews);

	const toggleExpandCheckedOut = () => {
		setIsExpandedCheckedOut(!isExpandedCheckedOut);
	};

	const toggleExpandAddOns = () => {
		setIsExpandedAddOns((prev) => !prev);
	};

	const getCustomFlows = async () => {
		try {
			const propertyId = localStorage.getItem("selectedPropertyId");
			const response = await apiClient.get(
				`${baseUrl}/customFlow/${propertyId}`,
			);
			if (response.status === 200) {
				const newToken = response.headers["authorization"];
				if (newToken) {
					localStorage.setItem("accessToken", newToken.split(" ")[1]);
				}

				if (response.data?.result?.length > 0) {
					// console.log("DATAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",response.data)
					setCustomFlows([...response.data.result].reverse());
				} else {
					// console.warn("No flows found");
					// console.log(response.data.result)
					setCustomFlows([...response.data.result.customFlow].reverse());
				}
			} else {
				console.error("API error:", response);
			}
		} catch (error) {
			console.error("Error fetching data:", error);
		}
	};

	function classNames(...classes) {
		return classes.filter(Boolean).join(" ");
	}
	const fetchWorkflow = async () => {
		setLoading(true);

		try {
			const response = await apiClient.get(
				`${baseUrl}/workflow/${selectedPropertyId}`,
			);
			if (response.ok) {
				const newToken = response.headers.get("Authorization");
				if (newToken) {
					localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
				}
			}
			const data = response.data.result;
			console.log("pppppppppppp", data);
			setWorkflowData(data);
			setIsFaqEnabled(data.homeFlow.frequentlyAskedQuestionsEnabled);
			setFaqList(data.homeFlow.frequentlyAskedQuestions);
			setSelectedAmenities(data.homeFlow.amenities);

			// Pre-Arrival Flow
			setPreArrivalData({
				phoneNumber: data.preArrivalFlow.phoneNumber,
				emailAddress: data.preArrivalFlow.emailAddress,
				arrivalTime: data.preArrivalFlow.arrivalTime,
				vehicleMakeModelColor: data.preArrivalFlow.vehicleMakeModelColor,
				licensePlateNo: data.preArrivalFlow.licensePlateNo,
				specialRequests: data.preArrivalFlow.specialRequests,
				guestSignature: data.preArrivalFlow.guestSignature,
				guestIdProof: data.preArrivalFlow.guestIdProof,
				policies: data.preArrivalFlow.policies,
				primaryPolicy: data.preArrivalFlow.primaryPolicy,
				policyLink: data.preArrivalFlow.policyLink,
				extraPolicies: data.preArrivalFlow.extraPolicies,
				propertyPolicies: data.preArrivalFlow.propertyPolicies,
			});

			// In-House Flow
			setInHouseFlow({
				wifiDetailsEnabled: data.inHouseFlow.wifiDetailsEnabled,
				wifiDetails: data.inHouseFlow.wifiDetails,
				clickableLinksOrButtonsEnabled:
					data.inHouseFlow.clickableLinksOrButtonsEnabled,
				clickableLinksOrButtons: data.inHouseFlow.clickableLinksOrButtons,
				frequentlyAskedQuestionsEnabled:
					data.inHouseFlow.frequentlyAskedQuestionsEnabled,
				frequentlyAskedQuestions: data.inHouseFlow.frequentlyAskedQuestions,
			});

			// Checked Out Flow
			setCheckedOutFlow({
				frequentlyAskedQuestionsEnabled:
					data.checkedOutFlow.frequentlyAskedQuestionsEnabled,
				frequentlyAskedQuestions: data.checkedOutFlow.frequentlyAskedQuestions,
			});

			// AddOns Flow
			setAddOnsFlow({
				customAddOns: data.addOnsFlow.customAddOns,
				checkInOutAddOns: data.addOnsFlow.checkInOutAddOns,
				houseKeepingAddOns: data.addOnsFlow.houseKeepingAddOns,
				upgradeRoom: data.addOnsFlow.upgradeRoom,
			});

			// Reviews Flow
			setReviewsFlow({
				reviewsEnabled: data.reviewFlow && data.reviewFlow.reviewsEnabled,
				reviewsLink: data.reviewFlow && data.reviewFlow.reviewsLink,
				startLimitForReviewLink:
					data.reviewFlow && data.reviewFlow.startLimitForReviewLink,
			});
		} catch (error) {
			const errorMessage =
				error.response?.data?.message ||
				"Failed to fetch workflow data. Please try again.";
			toast.error(errorMessage);
		} finally {
			setLoading(false);
		}
	};

	const getTemplates = async () => {
		try {
			const response = await apiClient.get(
				`${baseUrl}/messageTemplate/${selectedPropertyId}`,
			);
			if (response.ok) {
				const newToken = response.headers.get("Authorization");
				if (newToken) {
					localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
				}
			}
			console.error("MESSAGE TEMPLATES");
			console.log(response.data.result);
			setTemplates(response.data.result.reverse());
		} catch (error) {
			console.error("Error fetching data:", error);
		}
	};
	const [templates, setTemplates] = useState([]);

	const [customFlows, setCustomFlows] = useState([]);

	const getTierNameById = (tierId, tiers) => {
		const tier = tiers.find((t) => t.id === tierId);
		return tier ? tier.tierType : "Unknown Tier";
	};

	useEffect(() => {
		getCustomFlows();
		getTemplates();
	}, [isNewFlowModalOpen]);
	useEffect(() => {
		if (selectedPropertyId) {
			fetchWorkflow();
			refreshUpgradeRoomData();
			refreshTierData();
		}

		getCustomFlows();
		getTemplates();
		fetchReviewJobs(); // Add this line to fetch review jobs
	}, [accessToken, selectedPropertyId]);
	console.log("aaaaaaaaaaaaa", addOnsFlow);
	const handleSaveChanges = async () => {
		setIsLoading(true);
		try {
			// Create a new FormData object
			const formData = new FormData();

			// Add each part of the workflow data to FormData
			formData.append(
				"homeFlow",
				JSON.stringify({
					...workflowData.homeFlow,
					amenities: selectedAmenities,
					frequentlyAskedQuestionsEnabled: isFaqEnabled,
					frequentlyAskedQuestions: faqList,
				}),
			);
			formData.append(
				"preArrivalFlow",
				JSON.stringify({
					...preArrivalData,
				}),
			);
			formData.append(
				"inHouseFlow",
				JSON.stringify({
					...inHouseFlow,
				}),
			);
			formData.append(
				"checkedOutFlow",
				JSON.stringify({
					...checkedOutFlow,
				}),
			);

			// Prepare add-ons flow data
			const addOnsWithImageInfo = {
				...addOnsFlow,
				checkInOutAddOns: addOnsFlow.checkInOutAddOns.map((addOn) => {
					const { image, previewUrl, ...rest } = addOn;
					return {
						...rest,
						image: image, // boolean flag indicating if an image was selected
						imageKey: image ? null : null, // Do not send imageKey for checkInOutAddOns
					};
				}),
				customAddOns: addOnsFlow.customAddOns.map((addOn, index) => {
					const { image, previewUrl, ...rest } = addOn;
					return {
						...rest,
						image: image, // boolean flag indicating if an image was selected
						imageKey: image ? `addOn_${index}` : null, // unique key for the image if present
					};
				}),
				houseKeepingAddOns: {
					...addOnsFlow.houseKeepingAddOns,
				},
				upgradeRoom: {
					...addOnsFlow.upgradeRoom,
				},
			};
			console.log("Housekeeping", addOnsFlow.houseKeepingAddOns);

			formData.append("addOnsFlow", JSON.stringify(addOnsWithImageInfo));

			// Append images for each custom add-on with unique keys
			addOnsFlow.customAddOns.forEach((addOn, index) => {
				if (addOn.image) {
					formData.append(`addOn_${index}`, addOn.image);
				}
			});

			formData.append(
				"reviewFlow",
				JSON.stringify({
					...reviewsFlow,
				}),
			);

			// Send the form data using axios
			await apiClient.put(
				`${baseUrl}/workflow/${selectedPropertyId}`,
				formData,
			);

			toast.success("Workflow updated successfully!");
			fetchWorkflow();
			getCustomFlows();
			getTemplates();
		} catch (error) {
			console.error("Error updating workflow:", error);
			const errorMessage =
				error.response?.data?.message ||
				"Failed to update workflow. Please try again.";
			toast.error(errorMessage);
		} finally {
			setIsLoading(false);
		}
	};

	const openNewFlowModal = () => {
		setIsNewFlowModalOpen(true);
	};

	// Function to close the modal
	const closeNewFlowModal = () => {
		setIsNewFlowModalOpen(false);
	};
	const redirectOptions = [
		{ label: "Greater than 1", value: "1" },
		{ label: "Greater than 2", value: "2" },
		{ label: "Greater than 3", value: "3" },
		{ label: "Greater than 4", value: "4" },
	];
	const [expandedFlows, setExpandedFlows] = useState({});

	const toggleExpand = (flowId) => {
		setExpandedFlows((prev) => ({
			...prev,
			[flowId]: !prev[flowId], // Toggle expand state for specific flow
		}));
	};

	const [flowStatuses, setFlowStatuses] = useState({});

	useEffect(() => {
		if (customFlows.length > 0) {
			const initialStatuses = customFlows.reduce((acc, flow) => {
				acc[flow._id] = flow.flowStatus ?? true; // Ensure true if undefined
				return acc;
			}, {});
			setFlowStatuses(initialStatuses);
		}
	}, [customFlows]);

	const toggleFlowStatus = (flowId) => {
		setFlowStatuses((prev) => ({
			...prev,
			[flowId]: !prev[flowId],
		}));
	};

	const handleUpdateWorkFlow = async (flow) => {
		const propertyId = localStorage.getItem("selectedPropertyId");
		const modifiedFlow = {
			...flow,
			flowStatus: flowStatuses[flow._id],
		};
		console.log(modifiedFlow);
		try {
			setFlowUpdateLoader(true);
			const response = await apiClient.put(
				`${baseUrl}/customFlow/${propertyId}`,
				modifiedFlow,
			);
			if (response.ok) {
				const newToken = response.headers.get("Authorization");
				if (newToken) {
					localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
				}
			}
			toast.success(response.data.message);
			// Reset state values after successful API call
			//resetFields();
		} catch (error) {
			console.log(error.response);
			let errorMessage =
				error.response?.data?.message ||
				"Failed to add the guest. Please try again.";
			toast.error(errorMessage);
		} finally {
			setFlowUpdateLoader(false);
		}
		//console.log(flow)
	};

	return (
		<>
			{loading && <LoadingSpinner />}
			<div className="bg-gray-100 p-12">
				<div className="flex items-center justify-between mb-4 sticky top-0 bg-gray-100 z-50 py-3">
					<h2 className="text-2xl font-semibold">Workflow</h2>

					<div className="flex">
						<button
							className="bg-[#4F46E5] hover:bg-indigo-500 text-white font-medium px-2 py-1.5 rounded-md m-2 flex items-center w-36"
							onClick={openNewFlowModal}
						>
							<CgAdd className="mr-1.5 text-[18px]" />
							New Flow
						</button>

						<button
							onClick={handleSaveChanges}
							className="bg-green-400 hover:bg-green-500 text-white font-medium px-2 py-1.5 rounded-md m-2 w-36"
						>
							{isLoading ? "Saving..." : "Save Changes"}
						</button>
					</div>
				</div>

				<div>
					{customFlows.map((flow) => (
						<div
							key={flow._id}
							className="bg-white shadow-md rounded-lg p-6 w-full mb-6"
						>
							<h3 className="text-xl font-semibold mb-2">
								{flow.name}
								<span className="text-xs text-gray-500 ml-2">(Custom)</span>
							</h3>
							<p className="text-gray-700">{flow.description}</p>

							<div className="flex justify-end mt-4 bg-gray-50 p-2 rounded-md">
								<button
									onClick={() => toggleExpand(flow._id)}
									className="text-indigo-500 hover:text-indigo-700 flex items-center text-sm"
								>
									{expandedFlows[flow._id] ? (
										<>
											View Less <CgChevronUp className="ml-1" />
										</>
									) : (
										<>
											View All <CgChevronDown className="ml-1" />
										</>
									)}
								</button>
							</div>

							{expandedFlows[flow._id] && (
								<div className="mt-4 bg-gray-50 p-4 rounded-lg">
									<p className="text-gray-700 font-bold">Trigger Event</p>
									<div className="mt-4">
										<input
											type="text"
											placeholder="Amenity"
											value={flow.trigger}
											readOnly
											className="border border-gray-300 rounded-md p-2 w-full mb-2"
										/>
									</div>
									<p className="text-gray-700 font-bold">Trigger Delay</p>
									<div className="mt-4">
										<input
											type="text"
											placeholder="Amenity"
											value={`${flow.timeDelay} minutes`}
											readOnly
											className="border border-gray-300 rounded-md p-2 w-full mb-2"
										/>
									</div>
									<p className="text-gray-700 font-bold">Template Name</p>
									<div className="mt-4">
										<textarea
											value={
												templates.find(
													(msg) => msg._id === flow.messageTemplateId,
												)?.name || "No message template found"
											}
											readOnly
											className="border border-gray-300 rounded-md p-2 w-full mb-2"
										/>
									</div>

									<p className="text-gray-700 font-bold">
										Template Description
									</p>
									<div className="mt-4">
										<textarea
											value={
												templates.find(
													(msg) => msg._id === flow.messageTemplateId,
												)?.message || "No message template found"
											}
											readOnly
											className="border border-gray-300 rounded-md p-2 w-full mb-2"
										/>
									</div>

									<div className="flex items-center justify-between mb-2 lg:mb-0">
										{/* Switch */}
										<Switch
											checked={flowStatuses[flow._id]}
											onChange={() => toggleFlowStatus(flow._id)}
											className={classNames(
												flowStatuses[flow._id]
													? "bg-indigo-600"
													: "bg-gray-200",
												"relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2",
											)}
										>
											<span
												aria-hidden="true"
												className={classNames(
													flowStatuses[flow._id]
														? "translate-x-5"
														: "translate-x-0",
													"pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out",
												)}
											/>
										</Switch>
										{/* Update Button */}
										<button
											onClick={() => handleUpdateWorkFlow(flow)}
											className="lg:ml-2 text-white font-semibold px-4 py-2 rounded-md text-[13px] focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600"
										>
											{flowUpdateLoader ? "Updating..." : "Update"}
										</button>
									</div>
								</div>
							)}
						</div>
					))}
				</div>

				{/* Reservation flow */}
				<div className="bg-white shadow-md rounded-lg p-6 w-full mb-6">
					<h3 className="text-xl font-semibold mb-2">Reservation Confirmed</h3>
					<p className="text-gray-700">
						All guests whose check-in dates are in the future or canceled in
						past.
					</p>
					<div className="flex justify-end mt-4 bg-gray-50 p-2 rounded-md">
						<button
							onClick={toggleExpandHome}
							className="text-indigo-500 hover:text-indigo-700 flex items-center text-sm"
						>
							{isExpandedHome ? (
								<>
									View Less <CgChevronUp className="ml-1" />
								</>
							) : (
								<>
									View All <CgChevronDown className="ml-1" />
								</>
							)}
						</button>
					</div>
					{isExpandedHome && (
						<div className="mt-4 bg-gray-50 p-4 rounded-lg">
							<div id="workflow-amenities">
								<p className="text-gray-700 font-bold">Amenities</p>
								<div className="mt-4">
								{selectedAmenities.map((amenity, index) => (
									<div key={index} className="flex items-center mb-2">
										<input
											type="checkbox"
											id={`amenity-${index}`}
											className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600 m-2"
											checked={amenity.enabled}
											onChange={(e) =>
												setSelectedAmenities((prev) =>
													prev.map((item, i) =>
														i === index
															? { ...item, enabled: e.target.checked }
															: item,
													),
												)
											}
										/>
										<label
											htmlFor={`amenity-${index}`}
											className="text-gray-700"
										>
											{amenity.name}
										</label>
									</div>
								))}
								</div>
							</div>

							{/* FAQ Switch */}
							<div className="mt-6 flex items-center justify-between">
								<label className="text-gray-800 font-bold text-lg">
									Frequently Asked Questions
								</label>
								<Switch
									checked={isFaqEnabled}
									onChange={setIsFaqEnabled}
									className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
								>
									<span
										aria-hidden="true"
										className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
									/>
								</Switch>
							</div>

							{/* FAQ List */}
							{isFaqEnabled && (
								<div className="mt-4">
									<h4 className="text-gray-700 font-bold mb-2">FAQs</h4>
									{faqList.map((faq, index) => (
										<div key={index} className="mb-4 flex items-center">
											<div className="flex-1">
												<input
													type="text"
													placeholder="Question"
													value={faq.question}
													onChange={(e) =>
														setFaqList((prev) =>
															prev.map((item, i) =>
																i === index
																	? { ...item, question: e.target.value }
																	: item,
															),
														)
													}
													className="border border-gray-300 rounded-md p-2 w-full mb-2"
												/>
												<input
													type="text"
													placeholder="Answer"
													value={faq.answer}
													onChange={(e) =>
														setFaqList((prev) =>
															prev.map((item, i) =>
																i === index
																	? { ...item, answer: e.target.value }
																	: item,
															),
														)
													}
													className="border border-gray-300 rounded-md p-2 w-full"
												/>
											</div>
											<button
												onClick={() =>
													setFaqList((prev) =>
														prev.filter((_, i) => i !== index),
													)
												}
												className="ml-2 mb-16 text-red-500 hover:text-red-700"
												aria-label="Delete FAQ"
											>
												<FaTrash className="w-5 h-5" />
											</button>
										</div>
									))}
									<button
										onClick={() =>
											setFaqList((prev) => [
												...prev,
												{ question: "", answer: "" },
											])
										}
										className="hover:text-500 text-[#4F46E5] font-medium mt-2"
									>
										<FaPlus className="inline mr-1" />
										Add Another FAQ
									</button>
								</div>
							)}
						</div>
					)}
				</div>
				{/*Amenities */}
				{/* <div className="bg-white shadow-md rounded-lg p-6 w-full mb-6">
					<h3 className="text-xl font-semibold mb-2">Amenities</h3>
					<p className="text-gray-700">
						All guests whose check-in dates are in the future or canceled in the
						past.
					</p>
					<div className="flex justify-end mt-4 bg-gray-50 p-2 rounded-md">
						<button
							onClick={toggleExpandAmenities}
							className="text-indigo-500 hover:text-indigo-700 flex items-center text-sm"
						>
							{isExpandedAmenities ? (
								<>
									View Less <CgChevronUp className="ml-1" />
								</>
							) : (
								<>
									View All <CgChevronDown className="ml-1" />
								</>
							)}
						</button>
					</div>

					{isExpandedAmenities && (
						<div className="flex flex-row flex-wrap gap-2 ">
							{selectedAmenities.map((amenity, index) => (
								<div
									key={index}
									className="relative"
									onMouseEnter={() => setHoveredIndex(index)} // Set hovered index on mouse enter
									onMouseLeave={() => setHoveredIndex(null)} // Reset hovered index on mouse leave
								>
									<img
										src={amenity.image}
										alt={amenity.name}
										className="h-14 w-14 border-gray-300 shadow-md cursor-pointer"
									/>
									<input
										type="checkbox"
										id={`amenity-${index}`}
										className="absolute top-2 left-2 h-5 w-5 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
										checked={amenity.enabled}
										onChange={(e) =>
											setSelectedAmenities((prev) =>
												prev.map((item, i) =>
													i === index
														? { ...item, enabled: e.target.checked }
														: item,
												),
											)
										}
									/>
									{hoveredIndex === index && ( // Show tooltip only for hovered index
										<div className="absolute z-10 px-2 py-1 text-sm text-white bg-black rounded shadow-lg -top-8 left-1/2 transform -translate-x-1/2 whitespace-nowrap">
											{amenity.name}
										</div>
									)}
								</div>
							))}
						</div>
					)}
				</div> */}

				{/* Pre-Arrival Flow */}
				<div
					id="pre-arrival-check-in"
					className="bg-white shadow-md rounded-lg p-6 w-full mb-6"
				>
					<h3 className="text-xl font-semibold mb-2">Pre Arrival Check In</h3>
					<p className="text-gray-700">
						This is some brief information about the pre-arrival check-in
						process.
					</p>
					<div className="flex justify-end mt-4 bg-gray-50 p-2 rounded-md">
						<button
							onClick={toggleExpandArrival}
							className="text-indigo-500 hover:text-indigo-700 flex items-center text-sm"
						>
							{isExpandedArrival ? (
								<>
									View Less <CgChevronUp className="ml-1" />
								</>
							) : (
								<>
									View All <CgChevronDown className="ml-1" />
								</>
							)}
						</button>
					</div>
					{isExpandedArrival && (
						<>
							<div className="mt-4 bg-gray-50 p-4 rounded-lg">
								<p className="text-gray-700 font-bold">Pre-Arrival Settings</p>
								<div className="mt-4 grid grid-cols-2 gap-4">
									{[
										{ label: "Phone Number", value: "phoneNumber" },
										{ label: "Email Address", value: "emailAddress" },
										{ label: "Arrival Time", value: "arrivalTime" },
										{
											label: "Vehicle Make/Model/Color",
											value: "vehicleMakeModelColor",
										},
										{ label: "License Plate No.", value: "licensePlateNo" },
										{ label: "Special Requests", value: "specialRequests" },
										{ label: "Guest Signature", value: "guestSignature" },
										{ label: "Guest ID Proof", value: "guestIdProof" },
										// { label: "Policies", value: "policies" },
									].map(({ label, value }) => {
										// Fields that should be disabled and always true
										const alwaysTrueFields = [
											// "phoneNumber",
											"arrivalTime",
											"guestSignature",
											"guestIdProof",
										];
										const isDisabled = alwaysTrueFields.includes(value);
										const isChecked = isDisabled
											? true
											: preArrivalData[value].show;

										return (
											<div
												key={value}
												className="flex items-center justify-between"
											>
												<label className="text-gray-800 font-medium">
													{label}
												</label>
												{/* <Switch
                          checked={isDisabled ? true : preArrivalData[value]}
                          onChange={(enabled) =>
                            !isDisabled &&
                            setPreArrivalData((prev) => ({
                              ...prev,
                              [value]: enabled,
                            }))
                          }
                          disabled={isDisabled}
                          className={`group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 ${
                            isChecked ? "bg-indigo-600" : "bg-gray-200"
                          } ${isDisabled ? "cursor-not-allowed" : ""}`}
                        >
                          <span
                            aria-hidden="true"
                            className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                              isDisabled
                                ? "translate-x-5"
                                : "group-data-[checked]:translate-x-5"
                            }`}
                          />
                        </Switch> */}
												{/*<Switch
                          checked={
                            isDisabled ? true : preArrivalData[value].show
                          }
                          onChange={(enabled) =>
                            !isDisabled &&
                            setPreArrivalData((prev) => ({
                              ...prev,
                              [value]: { ...prev[value], show: enabled },
                            }))
                          }
                          disabled={isDisabled}
                          className={`group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 ${
                            isChecked ? "bg-indigo-600" : "bg-gray-200"
                          } ${isDisabled ? "cursor-not-allowed" : ""}`}
                        >
                          <span
                            aria-hidden="true"
                            className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                              isDisabled
                                ? "translate-x-5"
                                : "group-data-[checked]:translate-x-5"
                            }`}
                          />
                        </Switch> */}
												<select
													value={preArrivalData[value]}
													key={value}
													name={label}
													className={`border border-gray-300 rounded-md p-2 min-w-32 text-sm ${
														isDisabled ? "bg-neutral-200" : "bg-white"
													}`}
													disabled={isDisabled}
													onChange={(e) =>
														setPreArrivalData((prev) => ({
															...prev,
															[value]: e.target.value,
														}))
													}
												>
													<option value="required">Required</option>
													<option value="optional">Optional</option>
													<option value="disabled">Disabled</option>
												</select>
											</div>
										);
									})}
								</div>
							</div>

							<div className="mt-4 bg-gray-50 p-4 rounded-lg">
								<div className="mt-6">
									<div className="flex flex-row justify-between">
										<div className="flex flex-col">
											<p className="text-gray-700 font-bold">
												Property Policies
											</p>
											<p className="text-gray-700 text-sm">
												(Each input below will be displayed as checkbox)
											</p>
										</div>

										<div className="flex items-center">
											<p className="text-gray-700 font-bold mr-2">
												Enable Policy
											</p>
											<Switch
												checked={preArrivalData.policies}
												onChange={(enabled) =>
													setPreArrivalData((prevData) => ({
														...prevData,
														policies: enabled, // Toggle the 'policies' field based on switch state
													}))
												}
												className={`group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 ${
													preArrivalData.policies
														? "bg-indigo-600"
														: "bg-gray-200"
												}`}
											>
												<span
													aria-hidden="true"
													className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
														preArrivalData.policies
															? "translate-x-5"
															: "translate-x-0"
													}`}
												/>
											</Switch>
										</div>
									</div>
								</div>

								<div className="mt-4">
									<label className="text-gray-800 font-medium">
										Extra Policies
									</label>

									{preArrivalData.propertyPolicies.map((policy, index) => (
										<div key={index} className="mb-4">
											{/* Input for Policy Title */}
											<div className="flex items-center mb-2">
												<input
													type="text"
													placeholder="Extra Policy Title"
													value={policy.name}
													onChange={(e) =>
														setPreArrivalData((prev) => ({
															...prev,
															propertyPolicies: prev.propertyPolicies.map(
																(item, i) =>
																	i === index
																		? { ...item, name: e.target.value }
																		: item,
															),
														}))
													}
													className="border border-gray-300 rounded-md p-2 w-full"
												/>
												<button
													onClick={() =>
														setPreArrivalData((prev) => ({
															...prev,
															propertyPolicies: prev.propertyPolicies.filter(
																(_, i) => i !== index,
															),
														}))
													}
													className="ml-2 text-red-500 hover:text-red-700"
													aria-label="Delete Extra Policy"
												>
													<FaTrash className="w-5 h-5" />
												</button>
											</div>

											{/* Textarea for Policy Description */}
											<textarea
												placeholder="Extra Policy Description"
												value={policy.description}
												onChange={(e) =>
													setPreArrivalData((prev) => ({
														...prev,
														propertyPolicies: prev.propertyPolicies.map(
															(item, i) =>
																i === index
																	? { ...item, description: e.target.value }
																	: item,
														),
													}))
												}
												className="border border-gray-300 rounded-md p-2 w-full"
											/>

											{/* Switch for Mandatory Policy */}
											<div className="flex items-center mt-2">
												<Switch
													checked={policy.isMandatory}
													onChange={(value) =>
														setPreArrivalData((prev) => ({
															...prev,
															propertyPolicies: prev.propertyPolicies.map(
																(item, i) =>
																	i === index
																		? { ...item, isMandatory: value }
																		: item,
															),
														}))
													}
													className={`${
														policy.isMandatory ? "bg-indigo-500" : "bg-gray-300"
													} relative inline-flex items-center h-6 rounded-full w-11 transition-colors focus:outline-none`}
												>
													<span
														className={`${
															policy.isMandatory
																? "translate-x-6"
																: "translate-x-1"
														} inline-block w-4 h-4 transform bg-white rounded-full transition-transform`}
													/>
												</Switch>
												<span className="ml-2 text-gray-700">Mandatory</span>
											</div>
										</div>
									))}

									<button
										onClick={() =>
											setPreArrivalData((prev) => ({
												...prev,
												propertyPolicies: [
													...prev.propertyPolicies,
													{ name: "", description: "", isMandatory: false },
												],
											}))
										}
										className="hover:text-500 text-indigo-500 font-medium mt-2"
									>
										<FaPlus className="inline mr-1" />
										Add Another Policy
									</button>
								</div>
							</div>
						</>
					)}
				</div>

				{/* Add-Ons Flow */}
				<div
					id="workflow-addons-flow"
					className="bg-white shadow-md rounded-lg p-6 w-full mb-6"
				>
					<h3 className="text-xl font-semibold mb-2">Add-Ons Flow</h3>
					<p className="text-gray-700">
						Manage custom and check-in/check-out add-ons for your property.
					</p>

					<div className="flex justify-end mt-4 bg-gray-50 p-2 rounded-md">
						<button
							onClick={toggleExpandAddOns}
							className="text-indigo-500 hover:text-indigo-700 flex items-center text-sm"
						>
							{isExpandedAddOns ? (
								<>
									View Less <CgChevronUp className="ml-1" />
								</>
							) : (
								<>
									View All <CgChevronDown className="ml-1" />
								</>
							)}
						</button>
					</div>

					{isExpandedAddOns && (
						<div className="mt-4 bg-gray-50 p-4 rounded-lg">
							{/* House Keeping Add-On */}
							<div className="bg-white shadow-md rounded-lg p-6 w-full mb-6">
								<div className="flex flex-row justify-between mb-2">
									<h4 className="text-gray-700 font-bold mb-2">
										{addOnsFlow.houseKeepingAddOns.name}
									</h4>
									<Switch
										checked={addOnsFlow.houseKeepingAddOns.enabled}
										onChange={(checked) =>
											setAddOnsFlow((prev) => ({
												...prev,
												houseKeepingAddOns: {
													...prev.houseKeepingAddOns,
													enabled: checked,
												},
											}))
										}
										className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
									>
										<span
											aria-hidden="true"
											className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
										/>
									</Switch>
								</div>
								<textarea
									type="text"
									placeholder="Description"
									value={addOnsFlow.houseKeepingAddOns.description}
									onChange={(e) =>
										setAddOnsFlow((prev) => ({
											...prev,
											houseKeepingAddOns: {
												...prev.houseKeepingAddOns,
												description: e.target.value,
											},
										}))
									}
									className="border border-gray-300 rounded-md p-2 mb-2 w-full"
								/>
								<div>
									<h3 className="mt-1 mb-1">Options</h3>
									{addOnsFlow.houseKeepingAddOns.options.length === 0 && (
										<p className="text-gray-400 text-sm">
											No options added yet.
										</p>
									)}
									{addOnsFlow.houseKeepingAddOns.options.map(
										(option, index) => (
											<div key={index} className="mb-4 flex items-center gap-2">
												<div className="flex-1">
													<input
														type="text"
														placeholder="Option"
														value={option}
														onChange={(e) =>
															setAddOnsFlow((prev) => ({
																...prev,
																houseKeepingAddOns: {
																	...prev.houseKeepingAddOns,
																	options: prev.houseKeepingAddOns.options.map(
																		(item, i) =>
																			i === index ? e.target.value : item,
																	),
																},
															}))
														}
														className="border border-gray-300 rounded-md p-2 w-full"
													/>
												</div>
												<button
													onClick={() =>
														setAddOnsFlow((prev) => ({
															...prev,
															houseKeepingAddOns: {
																...prev.houseKeepingAddOns,
																options: prev.houseKeepingAddOns.options.filter(
																	(_, i) => i !== index,
																),
															},
														}))
													}
													className="text-red-500 hover:text-red-700"
													aria-label="Delete Option"
												>
													<FaTrash className="w-5 h-5" />
												</button>
											</div>
										),
									)}
									<button
										onClick={() =>
											setAddOnsFlow((prev) => ({
												...prev,
												houseKeepingAddOns: {
													...prev.houseKeepingAddOns,
													options: [...prev.houseKeepingAddOns.options, ""],
												},
											}))
										}
										className="hover:text-500 text-[#4F46E5] font-medium mt-2"
									>
										<FaPlus className="inline mr-1" />
										Add Options
									</button>
								</div>
								<div className="mt-4">
									{/* Header */}
									<div className="flex items-center justify-between mb-2">
										<label className="text-gray-700 font-medium">
											Service Timing
										</label>

										<Switch
											checked={
												addOnsFlow.houseKeepingAddOns.serviceTimingEnabled
											}
											onChange={(checked) =>
												setAddOnsFlow((prev) => ({
													...prev,
													houseKeepingAddOns: {
														...prev.houseKeepingAddOns,
														serviceTimingEnabled: checked,
													},
												}))
											}
											className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
										>
											<span
												aria-hidden="true"
												className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
											/>
										</Switch>
									</div>

									{/* Time Inputs */}
									<div
										className={`flex gap-4 transition ${
											!addOnsFlow.houseKeepingAddOns.serviceTimingEnabled
												? "opacity-50 pointer-events-none"
												: ""
										}`}
									>
										<input
											type="time"
											value={addOnsFlow.houseKeepingAddOns.serviceTiming.from}
											onChange={(e) =>
												setAddOnsFlow((prev) => ({
													...prev,
													houseKeepingAddOns: {
														...prev.houseKeepingAddOns,
														serviceTiming: {
															...prev.houseKeepingAddOns.serviceTiming,
															from: e.target.value,
														},
													},
												}))
											}
											className="border p-2 rounded w-full"
										/>

										<input
											type="time"
											value={addOnsFlow.houseKeepingAddOns.serviceTiming.to}
											onChange={(e) =>
												setAddOnsFlow((prev) => ({
													...prev,
													houseKeepingAddOns: {
														...prev.houseKeepingAddOns,
														serviceTiming: {
															...prev.houseKeepingAddOns.serviceTiming,
															to: e.target.value,
														},
													},
												}))
											}
											className="border p-2 rounded w-full"
										/>
									</div>

									{/* Optional helper text */}
									{!addOnsFlow.houseKeepingAddOns.serviceTimingEnabled && (
										<p className="text-xs text-gray-400 mt-1">
											Service timing is disabled
										</p>
									)}
								</div>
							</div>
							{/* Upgrade Room Add-On */}
							<div className="bg-white shadow-md rounded-lg p-6 w-full mb-6">
								<div className="flex flex-row justify-between mb-2">
									<h4 className="text-gray-700 font-bold mb-2">
										{addOnsFlow.upgradeRoom.name}
									</h4>
									<Switch
										checked={addOnsFlow.upgradeRoom.enabled}
										onChange={(checked) =>
											setAddOnsFlow((prev) => ({
												...prev,
												upgradeRoom: {
													...prev.upgradeRoom,
													enabled: checked,
												},
											}))
										}
										className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
									>
										<span
											aria-hidden="true"
											className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
										/>
									</Switch>
								</div>
								<textarea
									type="text"
									placeholder="Description"
									value={addOnsFlow.upgradeRoom.description}
									onChange={(e) =>
										setAddOnsFlow((prev) => ({
											...prev,
											upgradeRoom: {
												...prev.upgradeRoom,
												description: e.target.value,
											},
										}))
									}
									className="border border-gray-300 rounded-md p-2 mb-6 w-full"
								/>

								{/* Room Tiers Management */}
								<div className="mb-6">
									<h3 className="mt-6 mb-4">Room Tiers</h3>
									{tierType && tierType.length === 0 && (
										<p className="text-gray-400 text-sm">No tiers added yet.</p>
									)}
									{tierType &&
										tierType.map((tier, index) => (
											<div key={index}>
												<div className="mb-4 flex items-center gap-2">
													<div className="flex-1 grid grid-cols-2 gap-2">
														<input
															type="number"
															placeholder="Priority"
															value={tier.priority || ""}
															// onChange={(e) =>
															//   setAddOnsFlow((prev) => ({
															//     ...prev,
															//     upgradeRoom: {
															//       ...prev.upgradeRoom,
															//       tiers: prev.upgradeRoom.tiers.map((item, i) =>
															//         i === index ? { ...item, priority: e.target.value } : item
															//       ),
															//     },
															//   }))
															// }
															min="1"
															className="border border-gray-300 rounded-md p-2"
															readOnly
														/>
														<input
															type="text"
															placeholder="Tier Type"
															value={tier.tierType || ""}
															// onChange={(e) =>
															//   setAddOnsFlow((prev) => ({
															//     ...prev,
															//     upgradeRoom: {
															//       ...prev.upgradeRoom,
															//       tiers: prev.upgradeRoom.tiers.map((item, i) =>
															//         i === index ? { ...item, tierType: e.target.value } : item
															//       ),
															//     },
															//   }))
															// }
															className="border border-gray-300 rounded-md p-2"
															readOnly
														/>
													</div>
													<button
														// onClick={() =>
														//   setAddOnsFlow((prev) => ({
														//     ...prev,
														//     upgradeRoom: {
														//       ...prev.upgradeRoom,
														//       tiers: prev.upgradeRoom.tiers.filter((_, i) => i !== index),
														//     },
														//   }))
														// }
														onClick={() => openTierTypeModal(tier, "update")}
														className="text-blue-700 hover:text-blue-700 ml-2"
														aria-label="Edit Tier"
													>
														<FaEye className="w-5 h-5" />
													</button>
												</div>
												{index < addOnsFlow.upgradeRoom.tiers.length - 1 && (
													<hr className="border-gray-200 my-4" />
												)}
											</div>
										))}
									<button
										// onClick={() =>
										//     setAddOnsFlow((prev) => ({
										//       ...prev,
										//       upgradeRoom: {
										//         ...prev.upgradeRoom,
										//         tiers: [
										//           ...(prev.upgradeRoom.tiers || []),
										//           { priority: "", name: "" }
										//         ],
										//       },
										//     }))
										// }
										onClick={() => openTierTypeModal(null, "create")}
										className="hover:text-500 text-[#4F46E5] font-medium mt-2"
									>
										<FaPlus className="inline mr-1" />
										Add Tier
									</button>
								</div>

								<div>
									<h3 className="mt-6 mb-4">Options</h3>
									{roomType &&
										Array.isArray(roomType) &&
										roomType.length === 0 && (
											<p className="text-gray-400 text-sm">
												No options added yet.
											</p>
										)}
									{roomType &&
										Array.isArray(roomType) &&
										roomType.map((option, index) => (
											<div key={index}>
												<div className="mb-4 flex items-center gap-2">
													<div className="flex-1 grid grid-cols-2 gap-2">
														<input
															type="text"
															placeholder="Tier Type"
															value={getTierNameById(
																option.tierTypeId,
																addOnsFlow.upgradeRoom.tiers,
															)}
															// onChange={(e) =>
															//   setAddOnsFlow((prev) => ({
															//     ...prev,
															//     upgradeRoom: {
															//       ...prev.upgradeRoom,
															//       options: (prev.upgradeRoom.options || []).map((item, i) =>
															//         i === index ? { ...item, tierType: e.target.value } : item
															//       ),
															//     },
															//   }))
															// }
															className="border border-gray-300 rounded-md p-2"
															readOnly
														/>
														<input
															type="text"
															placeholder="Room Name"
															value={option.roomType}
															// onChange={(e) =>
															//   setAddOnsFlow((prev) => ({
															//     ...prev,
															//     upgradeRoom: {
															//       ...prev.upgradeRoom,
															//       options: (prev.upgradeRoom.options || []).map((item, i) =>
															//         i === index ? { ...item, roomType: e.target.value } : item
															//       ),
															//     },
															//   }))
															// }
															className="border border-gray-300 rounded-md p-2"
															readOnly
														/>
														<input
															type="text"
															placeholder="Price/Night"
															value={`$${option.price}` || ""}
															// onChange={(e) =>
															//   setAddOnsFlow((prev) => ({
															//     ...prev,
															//     upgradeRoom: {
															//       ...prev.upgradeRoom,
															//       options: (prev.upgradeRoom.options || []).map((item, i) =>
															//         i === index ? { ...item, price: e.target.value } : item
															//       ),
															//     },
															//   }))
															// }
															className="border border-gray-300 rounded-md p-2"
															readOnly
														/>
														<input
															type="text"
															placeholder="Room Code"
															value={
																option.roomCode
																	? option.roomCode
																	: "Room Code not mapped"
															}
															// onChange={(e) =>
															//   setAddOnsFlow((prev) => ({
															//     ...prev,
															//     upgradeRoom: {
															//       ...prev.upgradeRoom,
															//       options: (prev.upgradeRoom.options || []).map((item, i) =>
															//         i === index ? { ...item, image: e.target.value } : item
															//       ),
															//     },
															//   }))
															// }
															className={`border border-gray-300 rounded-md p-2 ${
																option.roomCode ? "text-black" : "text-gray-400"
															}`}
															readOnly
														/>
													</div>
													<button
														onClick={() => openRoomTypeModal(option, "update")}
														className="text-blue-700 hover:text-blue-700 ml-2"
														aria-label="View Option"
													>
														<FaEye className="w-5 h-5" />
													</button>
												</div>
												{index <
													(addOnsFlow.upgradeRoom.options || []).length - 1 && (
													<hr className="border-gray-200 my-4" />
												)}
											</div>
										))}
									<button
										// onClick={() =>
										//   setAddOnsFlow((prev) => ({
										//     ...prev,
										//     upgradeRoom: {
										//       ...prev.upgradeRoom,
										//       options: [
										//         ...prev.upgradeRoom.options,
										//         { roomNumber: "", roomType: "" },
										//       ],
										//     },
										//   }))
										// }
										onClick={() => openRoomTypeModal(null, "create")}
										className="hover:text-500 text-[#4F46E5] font-medium mt-2"
									>
										<FaPlus className="inline mr-1" />
										Add Option
									</button>
								</div>
							</div>

							{/* Check-In/Out Add-Ons */}
							{addOnsFlow.checkInOutAddOns.map((addOn, index) => (
								<div
									key={index}
									className="bg-white shadow-md rounded-lg p-6 w-full mb-6"
								>
									<div className="flex flex-row justify-between mb-2">
										<h4 className="text-gray-700 font-bold mb-2">
											{addOn.name}
										</h4>
										<Switch
											checked={addOn.enabled}
											onChange={(checked) =>
												setAddOnsFlow((prev) => ({
													...prev,
													checkInOutAddOns: prev.checkInOutAddOns.map(
														(item, i) =>
															i === index
																? { ...item, enabled: checked }
																: item,
													),
												}))
											}
											className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
										>
											<span
												aria-hidden="true"
												className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
											/>
										</Switch>
									</div>
									<input
										type="text"
										placeholder="Name"
										value={addOn.name}
										onChange={(e) =>
											setAddOnsFlow((prev) => ({
												...prev,
												checkInOutAddOns: prev.checkInOutAddOns.map(
													(item, i) =>
														i === index
															? { ...item, name: e.target.value }
															: item,
												),
											}))
										}
										className="border border-gray-300 rounded-md p-2 mb-2 w-full"
									/>
									<textarea
										type="text"
										placeholder="Description"
										value={addOn.description}
										onChange={(e) =>
											setAddOnsFlow((prev) => ({
												...prev,
												checkInOutAddOns: prev.checkInOutAddOns.map(
													(item, i) =>
														i === index
															? { ...item, description: e.target.value }
															: item,
												),
											}))
										}
										className="border border-gray-300 rounded-md p-2 mb-2 w-full"
									/>
									<textarea
										type="text"
										placeholder="Notes for guests about this service."
										value={addOn.addonNote}
										onChange={(e) =>
											setAddOnsFlow((prev) => ({
												...prev,
												checkInOutAddOns: prev.checkInOutAddOns.map(
													(item, i) =>
														i === index
															? { ...item, addonNote: e.target.value }
															: item,
												),
											}))
										}
										className="border border-gray-300 rounded-md p-2 mb-2 w-full"
									/>
									<div className="flex flex-row justify-between">
										<p className="text-gray-700">Allow until(timing)?</p>
										<input
											type="time"
											placeholder="Default Timing"
											value={addOn.defaultTiming}
											onChange={(e) =>
												setAddOnsFlow((prev) => ({
													...prev,
													checkInOutAddOns: prev.checkInOutAddOns.map(
														(item, i) =>
															i === index
																? { ...item, defaultTiming: e.target.value }
																: item,
													),
												}))
											}
											className="border border-gray-300 rounded-md p-2 mb-2 w-full"
										/>
									</div>
									<div className="flex flex-row justify-between mb-2">
										<label className="ml-2 text-gray-700">Paid</label>
										<Switch
											checked={addOn.paid}
											onChange={(checked) =>
												setAddOnsFlow((prev) => ({
													...prev,
													checkInOutAddOns: prev.checkInOutAddOns.map(
														(item, i) =>
															i === index ? { ...item, paid: checked } : item,
													),
												}))
											}
											className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
										>
											<span
												aria-hidden="true"
												className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
											/>
										</Switch>
									</div>
									<div className="flex flex-row items-center justify-center">
										<span className="px-2 text-xl -translate-y-[1px]">$</span>
										<input
											type="number"
											placeholder="Price"
											value={addOn.price !== "" ? addOn.price : ""}
											onChange={(e) => {
												const value = e.target.value;
												if (addOn.paid) {
													setAddOnsFlow((prev) => ({
														...prev,
														checkInOutAddOns: prev.checkInOutAddOns.map(
															(item, i) =>
																i === index
																	? {
																			...item,
																			price: value === "" ? "" : value,
																		}
																	: item,
														),
													}));
												}
											}}
											disabled={!addOn.paid}
											onBlur={(e) => {
												const value = parseFloat(e.target.value) || 0;
												if (addOn.paid) {
													setAddOnsFlow((prev) => ({
														...prev,
														checkInOutAddOns: prev.checkInOutAddOns.map(
															(item, i) =>
																i === index ? { ...item, price: value } : item,
														),
													}));
												}
											}}
											className="border border-gray-300 rounded-md p-2 mb-2 w-full"
										/>
									</div>
								</div>
							))}

							{/* Custom Add-Ons */}
							{addOnsFlow.customAddOns.map((addOn, index) => (
								<div
									key={index}
									className="relative bg-white shadow-md rounded-lg px-8 py-6 w-full mb-6"
								>
									<button
										onClick={() =>
											setAddOnsFlow((prev) => ({
												...prev,
												customAddOns: prev.customAddOns.filter(
													(_, i) => i !== index,
												),
											}))
										}
										className="absolute top-4 right-2 text-red-500 hover:text-red-700"
									>
										<FaTrash className="w-5 h-5" />
									</button>
									<div className="flex flex-row justify-between mb-2">
										<label className="ml-2 text-gray-700">Enabled</label>
										<Switch
											checked={addOn.enabled}
											onChange={(checked) =>
												setAddOnsFlow((prev) => ({
													...prev,
													customAddOns: prev.customAddOns.map((item, i) =>
														i === index ? { ...item, enabled: checked } : item,
													),
												}))
											}
											className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
										>
											<span
												aria-hidden="true"
												className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
											/>
										</Switch>
									</div>
									<input
										type="text"
										placeholder="Name"
										value={addOn.name}
										onChange={(e) =>
											setAddOnsFlow((prev) => ({
												...prev,
												customAddOns: prev.customAddOns.map((item, i) =>
													i === index
														? { ...item, name: e.target.value }
														: item,
												),
											}))
										}
										className="border border-gray-300 rounded-md p-2 mb-2 w-full"
									/>
									<input
										type="text"
										placeholder="Description"
										value={addOn.description}
										onChange={(e) =>
											setAddOnsFlow((prev) => ({
												...prev,
												customAddOns: prev.customAddOns.map((item, i) =>
													i === index
														? { ...item, description: e.target.value }
														: item,
												),
											}))
										}
										className="border border-gray-300 rounded-md p-2 mb-2 w-full"
									/>
									<textarea
										type="text"
										placeholder="Notes for guests about this service."
										value={addOn.addonNote}
										onChange={(e) =>
											setAddOnsFlow((prev) => ({
												...prev,
												customAddOns: prev.customAddOns.map((item, i) =>
													i === index
														? { ...item, addonNote: e.target.value }
														: item,
												),
											}))
										}
										className="border border-gray-300 rounded-md p-2 mb-2 w-full"
									/>
									{/* Image Upload */}
									<div className="mb-2">
										{addOn.image ? (
											<div className="flex flex-row items-center">
												<img
													src={
														addOn.previewUrl ? addOn.previewUrl : addOn.image
													}
													alt="Add-on preview"
													className="w-[50px] h-[50px] rounded-lg mb-2"
												/>
												<button
													onClick={() =>
														setAddOnsFlow((prev) => ({
															...prev,
															customAddOns: prev.customAddOns.map((item, i) =>
																i === index
																	? { ...item, image: null, previewUrl: null }
																	: item,
															),
														}))
													}
													className="text-red-500 hover:text-red-700"
												>
													Remove Image
												</button>
											</div>
										) : (
											<input
												type="file"
												accept="image/*"
												onChange={(e) => {
													const file = e.target.files[0];
													if (file) {
														const previewUrl = URL.createObjectURL(file);
														setAddOnsFlow((prev) => ({
															...prev,
															customAddOns: prev.customAddOns.map((item, i) =>
																i === index
																	? { ...item, image: file, previewUrl }
																	: item,
															),
														}));
													}
												}}
												className="border border-gray-300 rounded-md p-2 w-full"
											/>
										)}
									</div>
									<div className="flex flex-row justify-between mb-2">
										<label className="ml-2 text-gray-700">Paid</label>
										<Switch
											checked={addOn.paid}
											onChange={(checked) =>
												setAddOnsFlow((prev) => ({
													...prev,
													customAddOns: prev.customAddOns.map((item, i) =>
														i === index ? { ...item, paid: checked } : item,
													),
												}))
											}
											className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
										>
											<span
												aria-hidden="true"
												className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
											/>
										</Switch>
									</div>
									<div className="flex flex-row items-center justify-center">
										<span className="px-2 text-xl -translate-y-[1px]">$</span>
										<input
											type="number"
											placeholder="Price"
											value={addOn.price !== "" ? addOn.price : ""}
											onChange={(e) => {
												const value = e.target.value;
												if (addOn.paid) {
													setAddOnsFlow((prev) => ({
														...prev,
														customAddOns: prev.customAddOns.map((item, i) =>
															i === index
																? { ...item, price: value === "" ? "" : value }
																: item,
														),
													}));
												}
											}}
											disabled={!addOn.paid}
											onBlur={(e) => {
												const value = parseFloat(e.target.value) || 0;
												if (addOn.paid) {
													setAddOnsFlow((prev) => ({
														...prev,
														customAddOns: prev.customAddOns.map((item, i) =>
															i === index ? { ...item, price: value } : item,
														),
													}));
												}
											}}
											className="border border-gray-300 rounded-md p-2 mb-2 w-full"
										/>
									</div>
								</div>
							))}
							<button
								onClick={() =>
									setAddOnsFlow((prev) => ({
										...prev,
										customAddOns: [
											...prev.customAddOns,
											{
												name: "",
												description: "",
												paid: false,
												price: 0,
												enabled: false,
												image: null,
												previewUrl: null,
											},
										],
									}))
								}
								className="hover:text-500 text-[#4F46E5] font-medium mt-2"
							>
								<FaPlus className="inline mr-1" />
								Add Another Custom Add-On
							</button>
						</div>
					)}
				</div>

				{/* In-House Flow */}
				<div className="bg-white shadow-md rounded-lg p-6 w-full mb-6">
					<h3 className="text-xl font-semibold mb-2">In-House Flow</h3>
					<p className="text-gray-700">
						The goal is to streamline check-in, reduce wait times, and enhance
						the guest experience.
					</p>

					<div className="flex justify-end mt-4 bg-gray-50 p-2 rounded-md">
						<button
							onClick={toggleExpandInHouse}
							className="text-indigo-500 hover:text-indigo-700 flex items-center text-sm"
						>
							{isExpandedInHouse ? (
								<>
									View Less <CgChevronUp className="ml-1" />
								</>
							) : (
								<>
									View All <CgChevronDown className="ml-1" />
								</>
							)}
						</button>
					</div>

					{isExpandedInHouse && (
						<div className="mt-4 bg-gray-50 p-4 rounded-lg">
							{/* Wifi Details Switch */}
							<div className="mt-6 flex items-center justify-between">
								<label className="text-gray-800 font-bold text-lg">
									Wifi Details
								</label>
								<Switch
									checked={inHouseFlow.wifiDetailsEnabled}
									onChange={(checked) =>
										setInHouseFlow((prev) => ({
											...prev,
											wifiDetailsEnabled: checked,
										}))
									}
									className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
								>
									<span
										aria-hidden="true"
										className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
									/>
								</Switch>
							</div>

							{/* Wifi Details Input */}
							{inHouseFlow.wifiDetailsEnabled && (
								<div className="mb-4 mt-4">
									<input
										type="text"
										placeholder="Wifi Name"
										value={inHouseFlow.wifiDetails.wifiName}
										onChange={(e) =>
											setInHouseFlow((prev) => ({
												...prev,
												wifiDetails: {
													...prev.wifiDetails,
													wifiName: e.target.value,
												},
											}))
										}
										className="border border-gray-300 rounded-md p-2 w-full mb-2"
									/>
									<input
										type="text"
										placeholder="Wifi Instructions"
										value={inHouseFlow.wifiDetails.wifiInstructions}
										onChange={(e) =>
											setInHouseFlow((prev) => ({
												...prev,
												wifiDetails: {
													...prev.wifiDetails,
													wifiInstructions: e.target.value,
												},
											}))
										}
										className="border border-gray-300 rounded-md p-2 w-full"
									/>
								</div>
							)}

							{/* Clickable Links or Buttons Switch */}
							<div className="mt-6 flex items-center justify-between">
								<label className="text-gray-800 font-bold text-lg">
									Clickable Links or Buttons
								</label>
								<Switch
									checked={inHouseFlow.clickableLinksOrButtonsEnabled}
									onChange={(checked) =>
										setInHouseFlow((prev) => ({
											...prev,
											clickableLinksOrButtonsEnabled: checked,
										}))
									}
									className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
								>
									<span
										aria-hidden="true"
										className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
									/>
								</Switch>
							</div>

							{/* Manage Clickable Links or Buttons */}
							{inHouseFlow.clickableLinksOrButtonsEnabled && (
								<div className="mb-4 mt-4">
									{inHouseFlow.clickableLinksOrButtons.map((link, index) => (
										<input
											key={index}
											type="text"
											placeholder="Link/Button"
											value={link}
											onChange={(e) =>
												setInHouseFlow((prev) => ({
													...prev,
													clickableLinksOrButtons:
														prev.clickableLinksOrButtons.map((item, i) =>
															i === index ? e.target.value : item,
														),
												}))
											}
											className="border border-gray-300 rounded-md p-2 w-full mb-2"
										/>
									))}
									{/* <button
                onClick={() =>
                  setInHouseFlow((prev) => ({
                    ...prev,
                    clickableLinksOrButtons: [
                      ...prev.clickableLinksOrButtons,
                      "",
                    ],
                  }))
                }
                className="text-blue-500 hover:text-blue-700"
              >
                Add Another Link/Button
              </button> */}
								</div>
							)}

							{/* FAQ Switch */}
							<div className="mt-6 flex items-center justify-between">
								<label className="text-gray-800 font-bold text-lg">
									Frequently Asked Questions
								</label>
								<Switch
									checked={inHouseFlow.frequentlyAskedQuestionsEnabled}
									onChange={(checked) =>
										setInHouseFlow((prev) => ({
											...prev,
											frequentlyAskedQuestionsEnabled: checked,
										}))
									}
									className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
								>
									<span
										aria-hidden="true"
										className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
									/>
								</Switch>
							</div>

							{/* FAQ List */}
							{inHouseFlow.frequentlyAskedQuestionsEnabled && (
								<div className="mt-4">
									<h4 className="text-gray-700 font-bold mb-2">FAQs</h4>
									{inHouseFlow.frequentlyAskedQuestions.map((faq, index) => (
										<div key={index} className="mb-4 flex items-center">
											<div className="flex-1">
												<input
													type="text"
													placeholder="Question"
													value={faq.question}
													onChange={(e) =>
														setInHouseFlow((prev) => ({
															...prev,
															frequentlyAskedQuestions:
																prev.frequentlyAskedQuestions.map((item, i) =>
																	i === index
																		? { ...item, question: e.target.value }
																		: item,
																),
														}))
													}
													className="border border-gray-300 rounded-md p-2 w-full mb-2"
												/>
												<input
													type="text"
													placeholder="Answer"
													value={faq.answer}
													onChange={(e) =>
														setInHouseFlow((prev) => ({
															...prev,
															frequentlyAskedQuestions:
																prev.frequentlyAskedQuestions.map((item, i) =>
																	i === index
																		? { ...item, answer: e.target.value }
																		: item,
																),
														}))
													}
													className="border border-gray-300 rounded-md p-2 w-full"
												/>
											</div>
											<button
												onClick={() =>
													setInHouseFlow((prev) => ({
														...prev,
														frequentlyAskedQuestions:
															prev.frequentlyAskedQuestions.filter(
																(_, i) => i !== index,
															),
													}))
												}
												className="ml-2 mb-16 text-red-500 hover:text-red-700"
												aria-label="Delete FAQ"
											>
												<FaTrash className="w-5 h-5" />
											</button>
										</div>
									))}
									<button
										onClick={() =>
											setInHouseFlow((prev) => ({
												...prev,
												frequentlyAskedQuestions: [
													...prev.frequentlyAskedQuestions,
													{ question: "", answer: "" },
												],
											}))
										}
										className="hover:text-500 text-[#4F46E5] font-medium mt-2"
									>
										<FaPlus className="inline mr-1" />
										Add Another FAQ
									</button>
								</div>
							)}
						</div>
					)}
				</div>

				{/* Checked Out Flow */}
				<div className="bg-white shadow-md rounded-lg p-6 w-full mb-6">
					<h3 className="text-xl font-semibold mb-2">Checked Out Flow</h3>
					<p className="text-gray-700">
						The goal is to streamline the checkout process, reduce wait times,
						and ensure guest satisfaction.
					</p>

					<div className="flex justify-end mt-4 bg-gray-50 p-2 rounded-md">
						<button
							onClick={toggleExpandCheckedOut}
							className="text-indigo-500 hover:text-indigo-700 flex items-center text-sm"
						>
							{isExpandedCheckedOut ? (
								<>
									View Less <CgChevronUp className="ml-1" />
								</>
							) : (
								<>
									View All <CgChevronDown className="ml-1" />
								</>
							)}
						</button>
					</div>

					{isExpandedCheckedOut && (
						<div className="mt-4 bg-gray-50 p-4 rounded-lg">
							{/* FAQ Switch */}
							<div className="mt-6 flex items-center justify-between">
								<label className="text-gray-800 font-bold text-lg">
									Frequently Asked Questions
								</label>
								<Switch
									checked={checkedOutFlow.frequentlyAskedQuestionsEnabled}
									onChange={(checked) =>
										setCheckedOutFlow((prev) => ({
											...prev,
											frequentlyAskedQuestionsEnabled: checked,
										}))
									}
									className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
								>
									<span
										aria-hidden="true"
										className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
									/>
								</Switch>
							</div>

							{/* FAQ List */}
							{checkedOutFlow.frequentlyAskedQuestionsEnabled && (
								<div className="mt-4">
									<h4 className="text-gray-700 font-bold mb-2">FAQs</h4>
									{checkedOutFlow.frequentlyAskedQuestions.map((faq, index) => (
										<div key={index} className="mb-4 flex items-center">
											<div className="flex-1">
												<input
													type="text"
													placeholder="Question"
													value={faq.question}
													onChange={(e) =>
														setCheckedOutFlow((prev) => ({
															...prev,
															frequentlyAskedQuestions:
																prev.frequentlyAskedQuestions.map((item, i) =>
																	i === index
																		? { ...item, question: e.target.value }
																		: item,
																),
														}))
													}
													className="border border-gray-300 rounded-md p-2 w-full mb-2"
												/>
												<input
													type="text"
													placeholder="Answer"
													value={faq.answer}
													onChange={(e) =>
														setCheckedOutFlow((prev) => ({
															...prev,
															frequentlyAskedQuestions:
																prev.frequentlyAskedQuestions.map((item, i) =>
																	i === index
																		? { ...item, answer: e.target.value }
																		: item,
																),
														}))
													}
													className="border border-gray-300 rounded-md p-2 w-full"
												/>
											</div>
											<button
												onClick={() =>
													setCheckedOutFlow((prev) => ({
														...prev,
														frequentlyAskedQuestions:
															prev.frequentlyAskedQuestions.filter(
																(_, i) => i !== index,
															),
													}))
												}
												className="ml-2 mb-16 text-red-500 hover:text-red-700"
												aria-label="Delete FAQ"
											>
												<FaTrash className="w-5 h-5" />
											</button>
										</div>
									))}
									<button
										onClick={() =>
											setCheckedOutFlow((prev) => ({
												...prev,
												frequentlyAskedQuestions: [
													...prev.frequentlyAskedQuestions,
													{ question: "", answer: "" },
												],
											}))
										}
										className="hover:text-500 text-[#4F46E5] font-medium mt-2"
									>
										<FaPlus className="inline mr-1" />
										Add Another FAQ
									</button>
								</div>
							)}
						</div>
					)}
				</div>

				{/* Reviews: link flow + review jobs */}
				<div className="bg-white shadow-md rounded-lg p-6 w-full mb-6">
					<h3 className="text-xl font-semibold mb-2">Reviews</h3>
					<p className="text-gray-700">
						Know what guests are saying about your property. Set your review link
						and when to show it, and manage review jobs for each platform.
					</p>

					<div className="flex justify-end mt-4 bg-gray-50 p-2 rounded-md">
						<button
							onClick={toggleExpandReviews}
							className="text-indigo-500 hover:text-indigo-700 flex items-center text-sm"
						>
							{isExpandedReviews ? (
								<>
									View Less <CgChevronUp className="ml-1" />
								</>
							) : (
								<>
									View All <CgChevronDown className="ml-1" />
								</>
							)}
						</button>
					</div>

					{isExpandedReviews && (
						<div className="mt-4 bg-gray-50 p-3 sm:p-4 rounded-lg space-y-8">
							<div>
								<h4 className="text-gray-800 font-bold text-lg mb-3">
									Review link
								</h4>
								<div className="mt-2 flex items-center justify-between">
									<label className="text-gray-800 font-bold text-base">
										Enable review link
									</label>
									<Switch
										checked={reviewsFlow.reviewsEnabled}
										onChange={(checked) =>
											setReviewsFlow((prev) => ({
												...prev,
												reviewsEnabled: checked,
											}))
										}
										className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
									>
										<span
											aria-hidden="true"
											className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
										/>
									</Switch>
								</div>
								{reviewsFlow.reviewsEnabled && (
									<div className="mb-2 mt-4">
										<input
											type="text"
											placeholder="Link/Button"
											value={reviewsFlow.reviewsLink}
											onChange={(e) =>
												setReviewsFlow((prev) => ({
													...prev,
													reviewsLink: e.target.value,
												}))
											}
											className="border border-gray-300 rounded-md p-2 w-full mb-2"
										/>
										<p className="font-bold mb-2">
											When to redirect guest to google reviews?
										</p>

										<select
											value={reviewsFlow.startLimitForReviewLink}
											onChange={(e) =>
												setReviewsFlow((prev) => ({
													...prev,
													startLimitForReviewLink: e.target.value,
												}))
											}
											className="border border-gray-300 rounded-md p-2 w-full"
										>
											{redirectOptions.map((option) => (
												<option key={option.value} value={option.value}>
													{option.label}
												</option>
											))}
										</select>
									</div>
								)}
							</div>

							<div className="border-t border-gray-200 pt-6">
								<h4 className="text-gray-800 font-bold text-lg mb-1">
									Review jobs
								</h4>
								<p className="text-gray-600 text-sm mb-4">
									Add review page URLs for each network and manage existing jobs.
								</p>
							{/* Add Review Job Form */}
							<div className="mb-4 sm:mb-6">
								<h4 className="text-gray-700 font-bold mb-3 text-sm sm:text-base">
									Add New Review Job
								</h4>
								<div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 mb-4">
									<div>
										<label className="block text-sm font-medium text-gray-700 mb-1">
											Network
										</label>
										<select
											value={newReviewJob.network}
											onChange={(e) =>
												setNewReviewJob({
													...newReviewJob,
													network: e.target.value,
												})
											}
											className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-indigo-500 focus:border-indigo-500"
										>
											<option value="">Select Network</option>
											{getAvailableNetworks().map((network) => (
												<option key={network.value} value={network.value}>
													{network.label}
												</option>
											))}
										</select>
									</div>
									<div>
										<div className="relative group cursor-pointer">
											<label className="block text-sm font-medium text-gray-700 mb-1">
												Business Page Link (Map){" "}
												<Info size={14} className="ml-1 inline-block" />
											</label>
											<div className="absolute left-24 top-full mt-1 w-max max-w-xs bg-gray-800 text-white text-xs rounded px-2 py-1 z-50 opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-normal shadow-lg">
												Link to your public profile page on the platform
												<br />
												{newReviewJob.network ? "For Example:" : ""}
												{newReviewJob.network === "tripadvisor"
													? "https://www.tripadvisor.in/Hotel_Review-g60713-d12290636-Reviews-Warfield_Hotel-San_Francisco_California.html"
													: newReviewJob.network === "google"
														? "https://www.google.com/maps?cid=472717649119152494"
														: newReviewJob.network === "booking"
															? "https://www.booking.com/hotel/us/warfield.en-gb.html"
															: newReviewJob.network === "expedia"
																? "https://www.expedia.co.in/San-Francisco-Hotels-Warfield-Hotel.h17383168.Hotel-Information"
																: newReviewJob.network === "agoda"
																	? "https://www.agoda.com/warfield-hotel_2/hotel/san-francisco-ca-us.html"
																	: newReviewJob.network === "yelp"
																		? "https://www.yelp.com/biz/warfield-hotel-san-francisco"
																		: ""}
											</div>
										</div>

										<input
											type="url"
											placeholder="https://example.com/reviews"
											value={newReviewJob.networkUrl}
											onChange={(e) =>
												setNewReviewJob({
													...newReviewJob,
													networkUrl: e.target.value,
												})
											}
											className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-indigo-500 focus:border-indigo-500"
										/>
									</div>
									<div>
										<div className="relative group cursor-pointer">
											<label className="block text-sm font-medium text-gray-700 mb-1">
												Direct Rating Link{" "}
												<Info size={14} className="ml-1 inline-block" />
											</label>
											<div className="absolute left-24 top-full mt-1 w-max max-w-xs bg-gray-800 text-white text-xs rounded px-2 py-1 z-50 opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-normal shadow-lg">
												Link that opens the review box directly (Saves guest clicks)
											</div>
										</div>

										<input
											type="url"
											placeholder="https://example.com/direct-review"
											value={newReviewJob.redirectUrl}
											onChange={(e) =>
												setNewReviewJob({
													...newReviewJob,
													redirectUrl: e.target.value,
												})
											}
											className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-indigo-500 focus:border-indigo-500"
										/>
									</div>
								</div>
								<button
									onClick={handleAddReviewJob}
									disabled={
										isAddingReviewJob ||
										!newReviewJob.network ||
										!newReviewJob.networkUrl ||
										!newReviewJob.redirectUrl
									}
									className="bg-indigo-600 hover:bg-indigo-700 disabled:bg-gray-400 text-white font-medium py-2 px-4 text-sm sm:text-base rounded-md transition-colors w-full sm:w-auto"
>								{isAddingReviewJob ? "Adding..." : "Add Review Job"}
								</button>
							</div>

							{/* Review Jobs List */}
							<div>
								<h4 className="text-gray-700 font-bold mb-3 text-sm sm:text-base">
									Existing Review Jobs
								</h4>
								{reviewsJobFlow.reviewJobs.length === 0 ? (
									<p className="text-gray-500 text-sm">
										No review jobs added yet.
									</p>
								) : (
									<div className="space-y-3">
										{reviewsJobFlow.reviewJobs.map((job) => (
											<div
												key={job._id || job.id}
												className="bg-white rounded-md border p-3 sm:p-4"
											>
												{editingJobId === job._id ? (
													// Edit Mode
													<div className="space-y-3">
														<div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
															<div>
																<label className="block text-sm font-medium text-gray-700 mb-1">
																	Network
																</label>
																<select
																	value={editingReviewJob.network}
																	disabled={true}
																	onChange={(e) =>
																		setEditingReviewJob({
																			...editingReviewJob,
																			network: e.target.value,
																		})
																	}
																	className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-indigo-500 focus:border-indigo-500"
																>
																	<option value="">Select Network</option>
																	{getAvailableNetworksForEdit(job.network).map(
																		(network) => (
																			<option
																				key={network.value}
																				value={network.value}
																			>
																				{network.label}
																			</option>
																		),
																	)}
																</select>
															</div>
															{/* <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                  Review Page URL
                                </label>
                                <input
                                  type="url"
                                  placeholder="https://example.com/reviews"
                                  value={editingReviewJob.networkUrl}
                                  onChange={(e) =>
                                    setEditingReviewJob({
                                      ...editingReviewJob,
                                      networkUrl: e.target.value,
                                    })
                                  }
                                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-indigo-500 focus:border-indigo-500"
                                />
                              </div> */}
															<div>
																<label className="block text-sm font-medium text-gray-700 mb-1">
																	Redirect URL
																</label>
																<input
																	type="url"
																	placeholder="https://example.com/redirect/reviews"
																	value={editingReviewJob.redirectUrl}
																	onChange={(e) =>
																		setEditingReviewJob({
																			...editingReviewJob,
																			redirectUrl: e.target.value,
																		})
																	}
																	className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-indigo-500 focus:border-indigo-500"
																/>
															</div>
														</div>
														<div className="flex flex-col sm:flex-row gap-2">
															<button
																onClick={handleUpdateReviewJob}
																disabled={
																	isUpdatingReviewJob ||
																	!editingReviewJob.redirectUrl
																}
																className="bg-green-600 hover:bg-green-700 disabled:bg-gray-400 text-white font-medium py-2 px-4 rounded-md transition-colors text-sm w-full sm:w-auto"
															>
																{isUpdatingReviewJob
																	? "Updating..."
																	: "Save Changes"}
															</button>
															<button
																onClick={handleCancelEdit}
																disabled={isUpdatingReviewJob}
																className="bg-gray-500 hover:bg-gray-600 disabled:bg-gray-400 text-white font-medium py-2 px-4 rounded-md transition-colors text-sm w-full sm:w-auto"
															>
																Cancel
															</button>
														</div>
													</div>
												) : (
													// View Mode
													<div>
														<div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-3">
															<div className="flex flex-wrap items-center gap-2 sm:gap-3">
																<span className="font-medium text-gray-900 capitalize text-base sm:text-lg">
																	{job.network}
																</span>
																<span className="text-xs bg-indigo-100 text-indigo-800 px-2 py-1 rounded-full">
																	{job.reviewJobId || "No Job ID"}{" "}
																	{job.isDefault}
																</span>
															</div>
															<div className="flex gap-2 w-full sm:w-auto">
																<button
																	onClick={() => handleEditReviewJob(job)}
																	className="text-blue-500 hover:text-blue-700 p-1"
																	title="Edit review job"
																>
																	<svg
																		className="w-4 h-4"
																		fill="none"
																		stroke="currentColor"
																		viewBox="0 0 24 24"
																	>
																		<path
																			strokeLinecap="round"
																			strokeLinejoin="round"
																			strokeWidth={2}
																			d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
																		/>
																	</svg>
																</button>
																<div className="flex items-center">
																	<input
																		id={`is-default-${job._id}`}
																		name={`is-default-${job._id}`}
																		type="checkbox"
																		className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
																		checked={job.isDefault}
																		onChange={(e) => {
																			handleIsDefault(
																				job._id,
																				e.target.checked,
																			);
																		}}
																	/>
																	<label
																		htmlFor={`is-default-${job._id}`}
																		className="ml-2 block text-sm leading-6 text-gray-700"
																	>
																		Default
																	</label>
																</div>
																<button
																	onClick={() =>
																		setConfirmModal({ open: true, review: job })
																	}
																	className="text-red-500 hover:text-red-700 p-1"
																	title="Delete review job"
																>
																	<FaTrash className="w-4 h-4" />
																</button>
															</div>
														</div>

														<div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 text-xs sm:text-sm">
															<div>
																<span className="font-medium text-gray-700">
																	Business Page:
																</span>
																<p className="text-gray-600 break-all text-xs sm:text-sm">
																	{job.networkUrl ||
																		job.networkUrl ||
																		"Not provided"}
																</p>
															</div>
															<div>
																<span className="font-medium text-gray-700">
																	UID:
																</span>
																<p className="text-gray-600 font-mono text-xs break-all">
																	{job.uid || "Not available"}
																</p>
															</div>
															<div>
																<span className="font-medium text-gray-700">
																	Slug:
																</span>
																<p className="text-gray-600 font-mono text-xs break-all">
																	{job.slug || "Not available"}
																</p>
															</div>
															<div>
																<span className="font-medium text-gray-700">
																	Job ID:
																</span>
																<p className="text-gray-600 font-mono text-xs break-all">
																	{job.reviewJobId || "Not available"}
																</p>
															</div>
															<div>
																<span className="font-medium text-gray-700">
																	Direct Link:
																</span>
																<p className="text-gray-600 break-all text-xs sm:text-sm">
																	{job.redirectUrl ||
																		job.redirectUrl ||
																		"Not provided"}
																</p>
															</div>
														</div>
													</div>
												)}
											</div>
										))}
									</div>
								)}
							</div>
						</div>
						</div>
					)}
				</div>

				{/* New Flow Modal */}
				{isNewFlowModalOpen && <NewFlowModal onClose={closeNewFlowModal} />}

				{/* Room Type Modal */}
				{isRoomTypeModalOpen && (
					<RoomType
						isOpen={isRoomTypeModalOpen}
						onClose={closeRoomTypeModal}
						roomData={selectedRoomData}
						action={roomTypeAction}
						onDataChange={refreshUpgradeRoomData}
					/>
				)}

				{/* Tier Type Modal */}
				{isTierTypeModalOpen && (
					<TierType
						isOpen={isTierTypeModalOpen}
						onClose={closeTierTypeModal}
						tierData={selectedTierData}
						action={tierTypeAction}
						onDataChange={refreshTierData}
					/>
				)}
			</div>
			<ConfirmModal
				open={confirmModal.open}
				review={confirmModal.review}
				onConfirm={handleDeleteReviewJob}
				onCancel={() => setConfirmModal({ open: false, review: null })}
			/>
		</>
	);
};
